import { NavLink } from 'react-router-dom';

import ZuiButton from '@zenbusiness/zui/Button';
import ZuiDivider from '@zenbusiness/zui/Divider';
import ZuiLink from '@zenbusiness/zui/Link';
import ZuiMenu from '@zenbusiness/zui/Menu';
import ZuiSkeleton from '@zenbusiness/zui/SkeletonText';
import { superstyled } from '@zenbusiness/zui/styles';

export const Button = superstyled({
  name: 'BusinessEntitySelector',
  slot: 'Button',
  tag: ZuiButton,
  propsNeeded: ['open'],
  styles: ({ theme, open }) => ({
    display: 'flex',
    gap: '0.5rem',
    justifyContent: 'space-between',
    maxWidth: '100%',
    width: '100%',
    minWidth: 'auto',

    '&.MuiButtonBase-root': {
      borderRadius: theme.shape.rounded.md,
      height: 'auto'
    },

    '& > .ZuiButton-content': {
      maxWidth: 'calc(100% - 3.25rem)'
    },

    [theme.breakpoints.up('md')]: {
      fontSize: '1.25rem',
      width: 'auto',

      ...(!open && {
        background: theme.palette.background.grey.dark,
        color: theme.palette.text.primary,

        '&:hover': {
          background: theme.palette.background.grey.darker
        }
      })
    },

    [theme.breakpoints.down('md')]: {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      '&:hover': {
        background: theme.palette.primary.main.darker
      },

      ...(open && {
        background: theme.palette.primary.main.light
      })
    }
  })
});

export const Divider = superstyled({
  name: 'BusinessEntitySelector',
  slot: 'Divider',
  tag: ZuiDivider,
  styles: {
    border: 'none',
    height: 1
  }
});

const linkStyles = ({ theme }) => ({
  display: 'flex',
  gap: '0.75rem',
  padding: '0.75rem 1.5rem',
  fontSize: '1rem',
  lineHeight: '1.5',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    fontSize: '1.125rem'
  },

  [theme.breakpoints.up('md')]: {
    fontSize: '1.25rem',
    lineHeight: '1.75rem'
  },

  [theme.breakpoints.up('lg')]: {
    fontSize: '1.375rem',
    paddingBlock: '1.125rem'
  }
});

export const InternalLink = superstyled({
  name: 'BusinessEntitySelector',
  slot: 'InternalLink',
  tag: NavLink,
  styles: linkStyles
});

export const ExternalLink = superstyled({
  name: 'BusinessEntitySelector',
  slot: 'ExternalLink',
  tag: ZuiLink,
  styles: linkStyles
});

export const Menu = superstyled({
  name: 'BusinessEntitySelector',
  slot: 'Menu',
  tag: ZuiMenu,
  styles: ({ theme }) => ({
    '& .MuiMenu-paper': {
      border: 'none',
      borderRadius: theme.shape.rounded.lg,
      boxShadow: '0 0.5rem 1rem 0.25rem rgba(46, 46, 46, 0.15)',
      marginTop: '0.25rem',
      padding: '14px 0px',
      width: '100%'
    },
    '&:focus': {
      boxShadow: 'none'
    },
    '& .MuiList-padding': {
      padding: 0
    },
    '& .MuiListItem-button:hover': {
      background: 'none'
    },
    [theme.breakpoints.up('md')]: {
      width: 500
    }
  })
});

export const Skeleton = superstyled({
  name: 'BusinessEntitySelector',
  slot: 'Skeleton',
  tag: ZuiSkeleton,
  styles: ({ theme }) => ({
    width: '100%',
    maxWidth: '100%',
    transform: 'unset',
    borderRadius: theme.shape.rounded.md,
    height: 'auto',
    padding: '0.75rem 1rem',

    [theme.breakpoints.up('md')]: {
      width: '16rem',
      fontSize: '1.25rem',
      padding: '1.125rem'
    }
  })
});
